import {
  getCountryCallingCode,
  parsePhoneNumberFromString,
  type CountryCode,
} from "libphonenumber-js";
import { z } from "zod";

export function normalizePhoneNumber(value: string, defaultCountry?: string | null): string | null {
  const input = value.trim();
  if (!input) return null;

  const country = defaultCountry?.trim().toUpperCase();
  const parsed = parsePhoneNumberFromString(
    input,
    country && /^[A-Z]{2}$/.test(country) ? (country as CountryCode) : undefined,
  );

  return parsed?.isValid() ? parsed.number : null;
}

export function getPhoneCountryCallingCode(value: string): string | null {
  const country = value.trim().toUpperCase();
  if (!/^[A-Z]{2}$/.test(country)) return null;

  try {
    return getCountryCallingCode(country as CountryCode);
  } catch {
    return null;
  }
}

export const phoneNumberSchema = z.string().transform((value, context) => {
  const normalized = normalizePhoneNumber(value);
  if (normalized) return normalized;

  context.addIssue({ code: "custom", message: "Enter a valid international phone number" });
  return z.NEVER;
});

export function maskPhoneNumber(value: string): string {
  const suffix = value.slice(-4);
  return suffix ? `***${suffix}` : "***";
}
